import React, {useCallback, useState} from 'react';

import DropDownOption from './DropDownOption';
import {Options} from '../../utils/types';
import PropTypes from 'prop-types';

interface Props {
  placeholder: string;
  options: Options[];
  extra?: React.ReactElement;
  callback: ({label, value}) => void;
  className?: string;
}

const Dropdown = ({placeholder, options, callback, extra, className}: Props) => {
  const [option, setOption] = useState({label: placeholder, value: null});
  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const onClickMenu = useCallback(() => {
    setDropdownOpen(!isDropdownOpen);
  }, [isDropdownOpen]);
  const onClickOption = useCallback(
    ({label, value, disabled}) => {
      if (disabled) return;
      setOption({label, value});
      setDropdownOpen(false);
      if (callback) {
        callback({label, value});
      }
    },
    [callback]
  );
  return (
    <div className={`${className} ecr-dropdown ${isDropdownOpen ? 'open' : ''}`}>
      <div className="ecr-dropdown-menu ecr-dropdown-row" onClick={onClickMenu} role="presentation">
        {option.label}
      </div>
      <div className="ecr-dropdown-list">
        {options.map(({label, value, disabled, disableMark}, index) => (
          <DropDownOption
            key={`option-${index}`}
            disabled={disabled}
            disableMark={disableMark}
            onClick={onClickOption}
            label={label}
            value={value}
          />
        ))}
        {extra}
      </div>
    </div>
  );
};

Dropdown.propTypes = {
  placeholder: PropTypes.string,
  options: PropTypes.array,
  callback: PropTypes.func,
  extra: PropTypes.string,
};

export default Dropdown;
